import React from 'react';
import classNames from 'classnames';

const Favourites = ({ className, ...r }) => {
	const classes = classNames('cln-favourites', className);

	return (
		<svg
			className={classes}
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 224 193"
			{...r}
		>
			<path
				fill="#FDB727"
				fillRule="evenodd"
				d="M13.086 105.72l-2.162.684-.684-2.162a1.061 1.061 0 00-2.023.64l.685 2.162-2.162.685a1.061 1.061 0 00.642 2.023l2.16-.685.684 2.161a1.063 1.063 0 001.332.691c.559-.176.868-.774.692-1.331l-.684-2.162 2.161-.684a1.06 1.06 0 00-.64-2.022z"
				clipRule="evenodd"
			></path>
			<path
				fill="#081FA0"
				fillRule="evenodd"
				d="M182.987 25.822a2.497 2.497 0 01-4.981.35 2.498 2.498 0 012.317-2.666 2.498 2.498 0 012.664 2.315z"
				clipRule="evenodd"
			></path>
			<path
				fill="#EAEBFF"
				fillRule="evenodd"
				d="M195.987 167.821a2.498 2.498 0 01-2.315 2.666 2.498 2.498 0 01-2.666-2.315 2.499 2.499 0 012.317-2.666 2.499 2.499 0 012.664 2.315zm-167-126a2.498 2.498 0 01-4.98.35 2.498 2.498 0 014.98-.35z"
				clipRule="evenodd"
			></path>
			<path
				fill="#126FFF"
				fillRule="evenodd"
				d="M35.285 158.673a.791.791 0 00-.994-.516l-1.614.512-.511-1.616a.791.791 0 10-1.51.479l.51 1.615-1.613.511a.792.792 0 00.478 1.51l1.614-.512.51 1.615a.794.794 0 00.995.515.792.792 0 00.516-.994l-.511-1.613 1.615-.512a.792.792 0 00.515-.994z"
				clipRule="evenodd"
			></path>
			<path
				fill="#EAEBFF"
				fillRule="evenodd"
				d="M217.285 84.673a.79.79 0 00-.994-.516l-1.614.512-.511-1.615a.792.792 0 10-1.51.478l.511 1.615-1.614.51a.793.793 0 00.478 1.51l1.614-.51.511 1.614a.793.793 0 001.51-.48l-.511-1.612 1.615-.512a.793.793 0 00.515-.994z"
				clipRule="evenodd"
			></path>
			<path
				fill="#126FFF"
				fillRule="evenodd"
				d="M93.285 10.673a.791.791 0 00-.994-.515l-1.614.51-.511-1.615a.792.792 0 10-1.51.479l.51 1.615-1.613.51a.792.792 0 00.478 1.51l1.614-.51.51 1.614a.793.793 0 00.995.515.792.792 0 00.516-.994l-.511-1.613 1.615-.512a.792.792 0 00.515-.994z"
				clipRule="evenodd"
			></path>
			<circle
				cx="116"
				cy="103.5"
				r="80"
				stroke="#F2F2F2"
				strokeDasharray="2 8"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				opacity="0.4"
			></circle>
			<circle
				cx="116"
				cy="103.5"
				r="64"
				stroke="#F2F2F2"
				strokeDasharray="2 8"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				opacity="0.6"
			></circle>
			<g clipPath="url(#favourites-a)">
				<path
					fill="#FDB727"
					d="M129.699 135.496c-22.318.259-32.208-12.001-34.793-20.111-2.585-8.083.439-16.76 8.08-19.174a18.77 18.77 0 0114.621 1.355 18.597 18.597 0 0111.168-9.485c7.633-2.412 15.134 2.954 17.709 11.035 2.594 8.111 1.605 23.795-16.785 36.38z"
				></path>
				<path
					fill="#EF9B30"
					d="M129.697 135.493a50.974 50.974 0 01-9.434-.72c23.715-18.278 4.357-38.91.988-42.205a18.79 18.79 0 017.523-4.487c7.635-2.409 15.13 2.954 17.706 11.032 2.594 8.114 1.606 23.798-16.783 36.38z"
				></path>
				<path
					fill="#126FFF"
					d="M98.875 91.498c-9.3.108-13.42-5-14.497-8.38-1.078-3.367.182-6.983 3.366-7.988a7.82 7.82 0 016.092.564 7.75 7.75 0 014.654-3.952c3.18-1.005 6.305 1.231 7.378 4.598 1.081 3.38.669 9.914-6.993 15.158z"
				></path>
				<path
					fill="#0250C9"
					d="M98.874 91.497a21.207 21.207 0 01-3.93-.3c9.881-7.616 1.815-16.212.41-17.585a7.83 7.83 0 013.136-1.87c3.181-1.004 6.304 1.231 7.377 4.597 1.081 3.38.669 9.916-6.993 15.158z"
				></path>
				<path
					fill="#F7F7F4"
					d="M136.437 85.5c-4.649.053-6.71-2.501-7.248-4.19-.539-1.685.091-3.492 1.683-3.995a3.91 3.91 0 013.046.282 3.878 3.878 0 012.327-1.976c1.59-.502 3.153.616 3.689 2.3.541 1.689.334 4.956-3.497 7.578z"
				></path>
				<path
					fill="#CCC"
					d="M136.437 85.498c-.658.011-1.316-.039-1.965-.15 4.94-3.808.907-8.106.205-8.792a3.92 3.92 0 011.568-.935c1.59-.502 3.152.615 3.688 2.298.541 1.69.335 4.958-3.496 7.58z"
				></path>
			</g>
			<defs>
				<clipPath id="favourites-a">
					<path fill="#fff" d="M0 0h64v64H0z" transform="translate(84 71.5)"></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default Favourites;
